<template>
  <div
    v-if="
      (!isFeishu || feishuShow) &&
      !isApp &&
      (!isWechatFlag || weixinShow) &&
      (!isTudoApp || tudoShow) &&
      (!isSandsTalkFlutterApp || sandsTalkNative) &&
      (!isSandsTalkPhOutfieldApp || sandsTalkPhOutfieldApp) &&
      (!isWisdomRabbitApp || wisdomRabbitApp) &&
      (!isBranchManagerApp || branchManagerApp) &&
      (!isSandsTalkMSFlutterApp || sandsTalkMsFlutterApp)
    "
  >
    <NavBar
      :title="titleConfig.title"
      :fixed="titleConfig.fixed"
      :left-text="titleConfig.leftText"
      :left-arrow="titleConfig.leftArrow !== false ? true : false"
      :border="false"
      @click-left="onClickLeft(titleConfig.selfClick)"
      @click-right="onClickRight"
      z-index="500"
    >
      <template #title>
        <span v-if="showTitle">
          {{ titleConfig.title || $t(`${meta.title}`) }}
        </span>
        <slot v-else name="title"> </slot>
      </template>
      <template #right>
        <!-- <van-icon name="search" size="18" /> -->
        <slot name="right"> </slot>
      </template>
    </NavBar>
  </div>
</template>
<script setup lang="ts">
import { NavBar } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { isFeishu } from '@/utils/feishu'
import { isApp } from '@/utils/client'
import { isWechatFlag } from '@/utils/weixin'
import { isTudoApp } from '@/utils/tudo'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'

interface IProps {
  titleConfig?: {
    title?: string
    leftText?: string
    leftArrow?: boolean
    fixed?: boolean
    selfClick?: boolean
  }
  showTitle?: boolean
  feishuShow?: boolean
  weixinShow?: boolean
  tudoShow?: boolean
  wisdomRabbitApp?: boolean
  sandsTalkNative?: boolean
  sandsTalkPhOutfieldApp?: boolean
  branchManagerApp?: boolean
  sandsTalkMsFlutterApp?: boolean
}

const router = useRouter()
const route = useRoute()

withDefaults(defineProps<IProps>(), {
  titleConfig: () => {
    return {
      title: '',
      leftText: '',
      leftArrow: true,
      fixed: false,
      selfClick: false
    }
  },
  showTitle: true,
  feishuShow: false,
  weixinShow: false,
  tudoShow: false,
  wisdomRabbitApp: false
})

const emit = defineEmits<{ (event: 'goBack'): void; (event: 'rightClick'): void }>()

const meta = route.meta

const onClickLeft = (selfClick: boolean) => {
  if (!selfClick) {
    router.go(-1)
  }
  emit('goBack')
}
const onClickRight = () => {
  emit('rightClick')
}
</script>

<style scoped lang="less">
:deep(.van-nav-bar__content) {
  height: 44px;
  background-color: #fff;
}

:deep(.van-nav-bar__title) {
  color: #171921;
  font-weight: 600;
  font-size: 18px;
}

.van-nav-bar :deep(.van-icon) {
  font-size: 18px;
  color: #171921;
}

:deep(.van-nav-bar__text) {
  color: #171921;
}
</style>
